export const BLACK_CARD_PLACEHOLDER = '%c';

export const BLACK = 'black';
export const WHITE = 'white';
